export default "__VITE_ASSET__iMFvT2aG__"